/**
 * Authority Labeling Helpers
 * Shared source of truth for authority naming across Frontend (Wizard) and Backend (Artifacts).
 */

export function formatAuthorityName(val: string): string {
  const map: Record<string, string> = {
    // Identity / Directory
    'hris': 'HRIS',
    'ad': 'Active Directory (on-prem)',
    'azure_ad': 'Entra ID (Azure AD)',
    'entra': 'Entra ID (Azure AD)',
    'entra_id': 'Entra ID (Azure AD)',
    'entra_idp': 'Identity Provider (Entra/Okta)',
    'entra_okta': 'Identity Provider (Entra/Okta)',
    'okta': 'Okta',
    'directory': 'Directory Service',
    
    // Endpoint Management
    'intune': 'Intune',
    'sccm': 'MECM / SCCM',
    'mecm': 'MECM / SCCM',
    'jamf': 'Jamf',
    'endpoint_mgmt': 'Endpoint Management',
    
    // Discovery & Inventory
    'discovery': 'Discovery Tool',
    'axonius': 'Axonius',
    'lansweeper': 'Lansweeper',
    'tanium': 'Tanium',
    'manual': 'Manual / Spreadsheets',
    'network_scan': 'Network Scanner',
    
    // Security / Vuln
    'vuln_scanner': 'Vulnerability Scanner',
    'qualys': 'Qualys',
    'rapid7': 'Rapid7',
    
    // CMDB / Assets
    'servicenow': 'ServiceNow',
    'servicenow_cmdb': 'ServiceNow CMDB',
    'jira_assets': 'JSM Assets',
    'jsm_assets': 'JSM Assets',
    'cmdb': 'CMDB Tool',
    
    // Generic
    'hr_system': 'HR System',
    'other': 'Other',
    'not_sure': 'Not sure yet'
  };
  return map[val] || val;
}

export function formatAttributeName(val: string): string {
  const map: Record<string, string> = {
    'ownership': 'Owner / Primary user',
    'ownership_primary_user': 'Owner / Primary user',
    'department_costcenter': 'Department / Cost center',
    'department_cost_center': 'Department / Cost center',
    'lifecycle_status': 'Lifecycle status',
    'lifecycle_state': 'Lifecycle status',
    'compliance_state': 'Compliance state',
    'os_version': 'OS version / build',
    'device_name': 'Device name / hostname',
    'serial_asset_tag': 'Serial number / asset tag',
    'location': 'Location / site',
    'device_location': 'Device location',
    'assigned_groups': 'Groups / access tags',
    'software_inventory': 'Installed software inventory',
    'installed_software': 'Installed software',
    'patch_level': 'Patch level / status',
    'hardware_details': 'Hardware details',
    'encryption_status': 'Encryption status'
  };
  return map[val] || val;
}
